import Head from "next/head";

export default function AppHead({ title }) {
    let titleText = "سبکینو";
    if (title) titleText = `${title} | ${titleText}`;

    return (
        <Head>
            <title>{titleText}</title>
        </Head>
    );
}
